export default "/images/vendor/flag-icon-css/flags/4x3/es-ga.svg?fe67f0ec71b864386562f469760e5ba8";